"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages_cat = void 0;
exports.messages_cat = {
    Address: "A morada é obrigatório ",
    Province: "A Cidade é obrigatório",
    PostalCode: {
        required: "O código Postal é obrigatório",
        pattern: "O código postal não está no formato correcto",
    },
    Profiles: {
        required: "O tipo de empresa é obrigatório",
    },
    Number: "O número é obrigatório",
    City: "A localidade é obrigatório",
    Tariff: "A tarifa é obrigatório",
    ContractedPower: {
        required: "A potência contratada é obrigatório",
        pattern: "A potência não tem o formato correcto",
    },
    Name: "O nome é obrigatório",
    LastName: "O apelido é obrigatório",
    Email: {
        required: "O email é obrigatório",
        pattern: "Por favor, escreva um endereço de email válido. Por exemplo perez@dominio.com ",
        email: "Por favor, escreva um endereço de email válido. Por exemplo perez@dominio.com ",
    },
    referralEmployee: {
        required: "O nome do responsável é obrigatório",
    },
    referralEmail: {
        required: "-	O email do responsável é obrigatório",
        pattern: "Os domínios admitidos são endesa.com, enel.com, endesa.es i enel.es",
        email: "Por favor, escreva um endereço de email válido.",
    },
    Terms: "Deve aceitar as condições",
    documentNumber: {
        required: "O documento é obrigatório",
        pattern: "O formato do documento não é correto",
        nifES: "Por favor, introduza um NIF válido",
        dniES: "Por favor, introduza um número de identificação válido",
        nieES: "Por favor, introduza um NIE válido",
    },
    PhoneNumber: {
        required: "O telefone é obrigatório",
        minlength: "O telefone deve ter 9 números",
        number: "O telefone deve ser composto por números",
        phoneNumberEs: "O formato do telefone não está correto",
    },
    CUPS: {
        required: "O CPE é obrigatório",
        pattern: "O formato do CPE não está correto",
    },
    ContactName: {
        required: "O nome é obrigatório",
    },
    ContactLastName: {
        required: "O apelido é obrigatório",
    },
    ContactDocumentNumber: {
        required: "O documento é obrigatório",
        pattern: "O formato do documento não está correto",
        dniES: "Si us plau, introdueix un DNI vàlid",
        nieES: "Si us plau, introdueix un NIE vàlid",
    },
    TotalConsumption: {
        required: "O consumo é obligatorio",
        pattern: "O formato do consumo não está correto",
    },
};
